exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-items-dropdown[data-v-872ca734]{display:block}", ""]);

// exports
